export default __webpack_public_path__ + "static/media/2.531e13b9.jpg";